import React, { useEffect, useRef, useState } from 'react';
import { jwtDecode } from 'jwt-decode';
import arrowDown from './assets/arrowDown.svg'
import logoutIcon from './assets/logout.svg'
import headIcon from './assets/headIcon.svg'
import { useNavigate } from 'react-router-dom';
import { LOCAL_STORAGE_TOKEN_KEY } from '../../utils/constants';

function ProfileDropdown({ changePage, navValue, type }) {
    const [isOpenDropDown, setIsOpenDropDown] = useState(false);
    const [user, setUser] = useState(null)
    const dropdownRef = useRef(null);
    const navigate = useNavigate()

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpenDropDown(false);
            }
        }

        // Attach the event listener on component mount
        document.addEventListener('mousedown', handleClickOutside);

        // Clean up the event listener on component unmount
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const toggleDropdown = () => {
        setIsOpenDropDown(!isOpenDropDown);
    };

    const LogOut = async () => {
        window.localStorage.clear(); // Clear stored tokens and user data
    
        // Force a full refresh to pull the latest database data
        window.location.reload();
    
        navigate('/'); // Navigate to home/login page
    };
    

    // Decode the data 
    function decodeData(data) {
        return atob(data); // Base64 encoding
    }

    useEffect(() => {
        const storeToken = window.localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY);
        // Decode the JWT token
        const decodedToken = storeToken ? decodeData(storeToken) : null;
        const userInfo = decodedToken ? jwtDecode(decodedToken) : null;
        if (userInfo) {
            setUser(userInfo?.user)
        }
    }, [setUser])

    return (
        <div ref={dropdownRef} className="relative inline-block text-left w-full border md:border-none border-ravgray rounded-[50px] py-[14px]  md:py-0 ">
            
            <div className='px-[11px] md:px-0'>
                <button onClick={toggleDropdown} className='rounded-[50px] flex flex-row-reverse md:flex-row justify-end items-center gap-[10px] mg:gap-[12px] w-full'>
                <h1 className='md:hidden font-bold text-sm text-ravdeepblue'>{user?.first_name??''} {user?.last_name??''}</h1>

                    <div className=' flex items-center justify-center'>
                        <img src={arrowDown} alt="" className={` ${isOpenDropDown ? "rotate-180" : ""} w-[14.58px] h-[7.29px]`} />
                    </div>
                    <div className=' flex '>
                        <div className=' w-[50px] h-[50px] xl:w-[70px] xl:h-[70px] rounded-full flex items-center justify-center text-center bg-profile'>
                            <h1 className='font-bold text-white text-[20px] sm:text-[25px] xl:text-[30px] xl:leading-[40.5px]'>{user?.first_name?.substring(0, 1)}{user?.last_name?.substring(0, 1)}</h1>
                        </div>
                        {/* <img src={defaultProfilePic} alt="" className=' w-[45px] h-[45px] rounded-[45px]' /> */}
                    </div>
                </button>
            </div>

            {isOpenDropDown && (
                <div className={` origin-top-right absolute w-full  md:right-0 mt-[24px] md:mt-[17px] md:w-[251px] mg:w-[325px] rounded-[20px] shadow-input bg-white ring-1 ring-black ring-opacity-5`}>
                    <div
                        className=" flex flex-col py-[25px] gap-[17px]"
                        role="menu"
                        aria-orientation="vertical"
                        aria-labelledby="options-menu"
                    >
                        <button onClick={() => navigate('/profile')} className=" w-full flex  hover:bg-tcfbg gap-[12px]  px-[34px]">
                            <img src={headIcon} alt="headIcon" className=' w-[24px] h-[24px]' />
                            <h1 className=' font-bold text-[16px] leading-[21.6px]'>Profile</h1>
                        </button>
                        <button onClick={() => LogOut()} className=" w-full flex  hover:bg-tcfbg gap-[12px]  px-[34px]">
                            <img src={logoutIcon} alt="logoutIcon" className=' w-[24px] h-[24px]' />
                            <h1 className=' font-bold text-[16px] leading-[21.6px]'>Logout</h1>
                        </button>

                    </div>
                </div>
            )}
        </div>
    );
}

export default ProfileDropdown;
